import PropTypes from 'prop-types'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import ResponsiveImage from 'components/images/responsive-image'
import env from 'config/env'
import { withI18next } from 'lib/i18n/withI18next'
import { getFreeGiftCondition } from '../utils'
import styles from './style.scss'

const FreeGiftRow = ({
  isAdding,
  isDisabled,
  isEligible,
  onAddToBag,
  product,
  t,
}) => {
  const { condition, image, name } = product
  const imageFullPath = image?.path ? `${env.IMG_HOST}${image.path}` : null
  // Only worth computing/showing for a gift the shopper hasn't unlocked yet
  // -- an already-eligible gift has nothing left to spend/buy towards.
  const conditionText = !isEligible
    ? getFreeGiftCondition(condition, t, true)
    : ''

  return (
    <div className="free-gift-row">
      <style jsx>{styles}</style>
      <div className="free-gift-row__image">
        {imageFullPath && (
          <ResponsiveImage imgRatio={1} src={imageFullPath} alt={name} />
        )}
      </div>
      <div className="free-gift-row__info">
        <span className="free-gift-row__name">{name}</span>
        {!!conditionText && (
          <span className="free-gift-row__condition">{conditionText}</span>
        )}
      </div>
      <Button
        type={BUTTON_TYPES.outlinedLight}
        className="free-gift-row__add"
        disabled={!isEligible || isDisabled}
        onClick={() => onAddToBag(product)}
      >
        {isAdding ? t('Adding…') : t('Add to bag')}
      </Button>
    </div>
  )
}

FreeGiftRow.propTypes = {
  isAdding: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEligible: PropTypes.bool.isRequired,
  onAddToBag: PropTypes.func.isRequired,
  product: PropTypes.shape({
    condition: PropTypes.shape({}),
    id_product: PropTypes.number,
    image: PropTypes.shape({
      path: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(FreeGiftRow)
